import PropTypes from "prop-types";
import { useEffect } from "react";
import { isAuthenticated } from "./components/enter-form/utilities";
import DrawDetailsLayout from "./containers/draw-details-layout";
import Notifications from "./containers/notifications";
import { DrawDetailsProvider } from "./context/draw-details";
import { drawDetailsReducer } from "./state/draw-details/reducer";
import styles from "./styles";
import sdkProvider from "./utilities/sdk-provider";
import { trackPageEvent } from "./utilities/trackPageEvent";
import hasJustLoggedIn from "../../../shared/hasJustLoggedIn";

export default function EntrantsApp({ contentData }) {
  useEffect(() => {
    const trackLandingPageLoad = async () => {
      const authenticated = await isAuthenticated();
      let sProp29Value = "";
      if (authenticated) {
        const identity = await sdkProvider("identity");
        const profile = await identity.customer.profile();
        const isFirstLogin =
          profile.lastAction.isSignupEmail || profile.lastAction.isSignupSocial;

        sProp29Value =
          isFirstLogin && hasJustLoggedIn()
            ? "limited drops successful sign up" //Scenario 3
            : "limited drops successful login"; //Scenario 2
      }
      trackPageEvent({
        content: { layout: "limited-drops-page-load", sProp29Value },
      });
    };
    trackLandingPageLoad();
  }, []);

  return (
    <DrawDetailsProvider
      initialState={{
        loading: true,
        hasError: false,
        content: contentData,
        drawDetails: {},
        variants: [],
      }}
      reducer={drawDetailsReducer}
    >
      <div className={styles.container}>
        <DrawDetailsLayout />
      </div>
      <Notifications />
    </DrawDetailsProvider>
  );
}

EntrantsApp.propTypes = {
  contentData: PropTypes.object.isRequired,
};
